import { UnknownProviderError } from '../../errors/unknown-provider-error';

export class UnknownGoogleError extends UnknownProviderError {
	constructor(cause: any) {
		super(cause);
		this.name = 'UnknownGoogleError';
	}
}
